import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { LoaderService } from './loader.service';
 import { Headers, Http, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';
import { APIURLS} from '../_constants/constants';

@Injectable()
export  class  SessionTimeoutService {
  idleTime = 1800000;

  constructor(private loaderService: LoaderService,private http: Http) { }

  handleInactivity() {
    return new Observable(observer => {
      let timeout;

      const setInactive = () => {
        observer.next(true);
      };

      const resetTimer = () => {
        clearTimeout(timeout);
        timeout = setTimeout(setInactive, this.idleTime);
      };

      // events - note: not tested for accessibility
      window.onload = resetTimer;
      document.onmousemove = resetTimer;
     // document.onmousedown = resetTimer;
      document.onkeydown = resetTimer;
      document.onscroll = resetTimer;
      document.ontouchstart = resetTimer;
      document.ontouchmove = resetTimer;
      document.onclick=resetTimer;
    });
  }

  setIdleTime(idleTime: number) {
    this.idleTime = idleTime;
  }
  
  
  logoutSession(){
    this.loaderService.display(true);
    localStorage.setItem('searchData',JSON.stringify({}));
    localStorage.setItem('language',"");
    localStorage.setItem('opco-header',"");
    localStorage.setItem('opco',"");
    localStorage.setItem('country',"");
    localStorage.setItem('localized',"");
    localStorage.setItem('setZone', null);
    localStorage.removeItem('createdDate');
    localStorage.removeItem('ModifieddDate');
    localStorage.removeItem("zoneModifiedDate");
    localStorage.removeItem("zoneCreatedDate");

    const URL = (environment.BASE_URL_BACKEND + APIURLS.AGENT_Operations_Logout);
    const headers = new Headers();

    const options = new RequestOptions({ headers: headers, withCredentials: true });
    // ATTENTION: Backend has to invalidate the session and in the positive case a redirect to first page will end in a fail in the filter
    this.http.post(URL, options).subscribe(
      response => {	      	
        window.location.href = '/';	        
      },
      error => {	      	
        window.location.href = '/';	        
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/_services/sessionTimeout.service.ts